import { BadgePercent, Ban, Handshake, TrendingDown } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";

const ICONS = [
  [Ban, "No Commissions"],
  [BadgePercent, "No Markups"],
  [TrendingDown, "Lowest Tickets"],
  [Handshake, "We Negotiate For You"],
];

export const NoCommissions = () => (
  <section className="relative overflow-hidden bg-gradient-to-br from-emerald-500 via-amber-400 to-purple-600 text-[#0A1F13] grain" data-testid="no-commissions-section">
    <div className="absolute -top-24 right-10 h-80 w-80 rounded-full bg-orange-500/40 blur-3xl" />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-20 sm:py-28 grid gap-12 lg:grid-cols-12 items-center">
      <Reveal className="lg:col-span-7">
        <span className="inline-flex rounded-full bg-[#0A1F13] text-amber-300 px-4 py-1.5 eyebrow">No Commissions. Ever.</span>
        <h2 className="mt-5 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05]">We Work For You, Not The Farm.</h2>
        <p className="mt-6 text-base sm:text-lg font-semibold leading-relaxed max-w-2xl">
          Once your one-time membership fee is paid, I'm The Plug Now does not make a single dollar from your purchases, now or in the future. No commissions, no markups, no hidden cuts.
        </p>
        <p className="mt-4 text-base sm:text-lg leading-relaxed max-w-2xl">
          After you pay, we work for <span className="font-extrabold">YOU</span>. We negotiate directly with the farm to get you the absolute best price for your money. Because we bring our farm partners consistent volume, they give us their lowest tickets, and we pass that pricing straight to our members.
        </p>
      </Reveal>
      <div className="lg:col-span-5 grid grid-cols-2 gap-4">
        {ICONS.map(([Icon, label], i) => (
          <Reveal key={label} delay={i * 0.08}>
            <div className="h-full rounded-3xl bg-[#0A1F13] text-white p-6 hover:-translate-y-1 transition-transform" data-testid={`no-commission-icon-${i}`}>
              <div className="h-12 w-12 rounded-2xl bg-gradient-to-br from-emerald-400 to-amber-400 grid place-items-center">
                <Icon className="h-6 w-6 text-[#0A1F13]" />
              </div>
              <p className="mt-4 font-display text-lg font-bold leading-tight">{label}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
